import { combineReducers } from "redux";

import basketOrderReducer from "./basketOrder.reducer";
import previewProductVideoReducer from "./previewProductVideo.reducer";
export default combineReducers({
  basketOrderReducer,
  previewProductVideoReducer,
});
